'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _merge = require('lodash/object/merge');

var _merge2 = _interopRequireDefault(_merge);

var _flattenMessages = require('common/utils/flatten-messages');

var _flattenMessages2 = _interopRequireDefault(_flattenMessages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDefaultMessages = function getDefaultMessages() {
    return (0, _flattenMessages2['default'])((0, _merge2['default'])(require('signer/translations/en-US.json'), require('signer/components/common/signature-modal/translations/en-US.json')));
};

var makeComponentIntl = function makeComponentIntl(component) {
    var InjectedComponent = (0, _reactIntl.injectIntl)(component);

    // Needs to be a class because refs are added by React Intl

    var IntlComponent = function (_React$Component) {
        _inherits(IntlComponent, _React$Component);

        function IntlComponent() {
            _classCallCheck(this, IntlComponent);

            return _possibleConstructorReturn(this, Object.getPrototypeOf(IntlComponent).apply(this, arguments));
        }

        _createClass(IntlComponent, [{
            key: 'render',
            value: function render() {
                var messages = this.props.messages || getDefaultMessages();
                return _jsx(_reactIntl.IntlProvider, {
                    locale: 'en-US',
                    messages: messages
                }, void 0, _react2['default'].createElement(InjectedComponent, this.props));
            }
        }]);

        return IntlComponent;
    }(_react2['default'].Component);

    return IntlComponent;
};

exports['default'] = makeComponentIntl;

module.exports = makeComponentIntl;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/make-component-intl.jsx
 ** module id = 637
 ** module chunks = 0
 **/